import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../SponsorsPage';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import RodapeLP from '../Home/modules/RodapeLP';
import Whatsapp from '../../components/Whatsapp';
import { ContactIcons } from 'src/components/MenuOld';
import { getYear } from 'date-fns';

const FooterLayout: React.FC = ({ children }) => {
  return (<><div style={{ position: 'relative', zIndex: 0, display: 'block' }}>

    {/* <ImageSliderBackground slides={['/apoio/fundo1.jpg', '/apoio/fundo2.jpg', '/apoio/fundo3.jpg']} /> */}


    <div className='row-to-column max-1400 full-width' style={{ zIndex: 2, position: 'relative', justifyContent: 'space-between', margin: '15px auto', paddingBottom: '10px' }}>
      <p style={{ color: '#fff', fontSize: '14px', padding: '10px' }} className="text-center-mobile">{getYear(new Date())} - © ADDMAX Soluções Comerciais - Todos os direitos reservados.</p>

    </div>
  </div>

  </>
  );
};

export default FooterLayout;
